import { Component, OnInit, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
	selector: 'app-modal-sub-renew',
	templateUrl: './modal-sub-renew.component.html',
	styleUrls: ['./modal-sub-renew.component.css']
})
export class ModalSubRenewComponent implements OnInit {
	public sliderValues: any[] = [];
	public endDate: string;
	// the number of month/year
	public quantity = 1;
	// selected term, year/month
	public selectedSlider = 1;
	// quantity unit
	public unit;

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data,
		public dialogRef: MatDialogRef<ModalSubRenewComponent>
	) { }
	public changeUnit (selectedSlider) {
		switch (this.sliderValues[selectedSlider].name) {
			case 'Year':
				this.unit = 'year';
				break;
			case 'Month':
				this.unit = 'month';
		}
		this.updateRenewDate(this.quantity, selectedSlider);
	}
	public updateRenewDate(quantity, selectedSlider) {
		if (!quantity) {
			this.endDate = null;
			return;
		} else {
			const date = new Date(this.data.expireDate);
			const year = date.getFullYear();
			const month = date.getMonth();
			const day = date.getDate();
			// Calculate end date
			switch (this.sliderValues[selectedSlider].name) {
				case 'Year':
					this.endDate = new Date(year + quantity, month, day).toISOString().split('T')[0];
					break;
				case 'Month':
					this.endDate = new Date(year, month + quantity, day).toISOString().split('T')[0];
			}
		}
	}
	public apply (selectedSlider) {
		this.dialogRef.close(
			{
				termName: this.sliderValues[selectedSlider].name,
				endDate: this.endDate,
			}
		);
	}
	public close () {
		this.dialogRef.close();
	}
	ngOnInit() {
		this.sliderValues = [
			{
				name: 'Month'
			}, {
				name: 'Year'
			}
		];
		if (this.selectedSlider === 1) {
			this.unit = 'year';
		} else {
			this.unit = 'month';
		}
		this.updateRenewDate(this.quantity, this.selectedSlider);
	}

}



// WEBPACK FOOTER //
// ./src/app/components/portal/subscription-manage/modal-sub-renew/modal-sub-renew.component.ts